import { useContext } from 'react';
import {
  EntityManagerContext,
  EntityManagerContextValue
} from '../../context/EntityManagerContext';

export function useEntityManager(): EntityManagerContextValue {
  return useContext(EntityManagerContext);
}
